// FETCH ALL COMBO_COLOR
export const FETCH_COMBO_COLOR_REQUEST = 'FETCH_COMBO_COLOR_REQUEST';
export const FETCH_COMBO_COLOR_SUCCESS = 'FETCH_COMBO_COLOR_SUCCESS';
export const FETCH_COMBO_COLOR_FAILURE = 'FETCH_COMBO_COLOR_FAILURE';

export const FETCH_COMBO_COLOR_LISTS_REQUEST = 'FETCH_COMBO_COLOR_LISTS_REQUEST';
export const FETCH_COMBO_COLOR_LISTS_SUCCESS = 'FETCH_COMBO_COLOR_LISTS_SUCCESS';
export const FETCH_COMBO_COLOR_LISTS_FAILURE = 'FETCH_COMBO_COLOR_LISTS_FAILURE';

// FETCH ALL COMBO_COLOR
export const RESET_COMBO_COLOR_FOR_PART_REQUEST = 'RESET_COMBO_COLOR_FOR_PART_REQUEST';
export const RESET_COMBO_COLOR_FOR_PART_SUCCESS = 'RESET_COMBO_COLOR_FOR_PART_SUCCESS';
export const RESET_COMBO_COLOR_FOR_PART_FAILURE = 'RESET_COMBO_COLOR_FOR_PART_FAILURE';

// UPDATE COMBO_COLOR
export const UPDATE_COMBO_COLOR_REQUEST = 'UPDATE_COMBO_COLOR_REQUEST';
export const UPDATE_COMBO_COLOR_SUCCESS = 'UPDATE_COMBO_COLOR_SUCCESS';
export const UPDATE_COMBO_COLOR_FAILURE = 'UPDATE_COMBO_COLOR_FAILURE';

export const RESET_COMBO_COLOR_ARRAY_DATA = 'RESET_COMBO_COLOR_ARRAY_DATA';


//FETCH INVOICE DATA
export const FETCH_COMBO_COLOR_INVOICE_REQUEST = 'FETCH_COMBO_COLOR_INVOICE_REQUEST';
export const FETCH_COMBO_COLOR_INVOICE_SUCCESS = 'FETCH_COMBO_COLOR_INVOICE_SUCCESS';
export const FETCH_COMBO_COLOR_INVOICE_FAILURE = 'FETCH_COMBO_COLOR_INVOICE_FAILURE';

export const RESET_COMBO_COLOR_INVOICE = 'RESET_COMBO_COLOR_INVOICE';

export const GET_FOLDING_FABRIC_REQUEST = 'GET_FOLDING_FABRIC_REQUEST';
export const GET_FOLDING_FABRIC_SUCCESS = 'GET_FOLDING_FABRIC_SUCCESS';
export const GET_FOLDING_FABRIC_FAILURE = 'GET_FOLDING_FABRIC_FAILURE';

export const DELETE_FOLDING_FABRIC_REQUEST = 'DELETE_FOLDING_FABRIC_REQUEST';
export const DELETE_FOLDING_FABRIC_SUCCESS = 'DELETE_FOLDING_FABRIC_SUCCESS';
export const DELETE_FOLDING_FABRIC_FAILURE = 'DELETE_FOLDING_FABRIC_FAILURE';

export const POST_FOLDING_FABRIC_REQUEST = 'POST_FOLDING_FABRIC_REQUEST';
export const POST_FOLDING_FABRIC_SUCCESS = 'POST_FOLDING_FABRIC_SUCCESS';
export const POST_FOLDING_FABRIC_FAILURE = 'POST_FOLDING_FABRIC_FAILURE';

export const GET_FOLDING_FABRIC_DETAILS_REQUEST = 'GET_FOLDING_FABRIC_DETAILS_REQUEST';
export const GET_FOLDING_FABRIC_DETAILS_SUCCESS = 'GET_FOLDING_FABRIC_DETAILS_SUCCESS';
export const GET_FOLDING_FABRIC_DETAILS_FAILURE = 'GET_FOLDING_FABRIC_DETAILS_FAILURE';